import { MessageBox } from 'element-ui'
import axios from 'axios'
export function v_update(that) {
    try {
        MessageBox.close()
    } catch (e) {
        // console.log(e)
    }

    // console.log(MessageBox)
    axios.get('V.json?time=' + new Date().getTime(), {}).then(res => {
        if (res.data.version) {
            that.version = res.data.version
        }
        init(that)

        const config = localStorage.getItem('config')
        if (!config && that.token) {
            config_init(that)
        }
    }).catch(function(error) {
    })
}
export function init(that) {
    const version = localStorage.getItem('sxhwj_admin_version')
    if (!version) {
        localStorage.setItem('sxhwj_admin_version', that.version)
        setVersion(that)
    } else if (version !== that.version) {
        setVersion(that)

    }
}
export function setVersion(that) {
    localStorage.setItem('sxhwj_admin_version', that.version)
    const str = '网站功能有更新,2秒后将刷新网页!'
    that.$message({
        message: str,
        type: 'warning'
    })
    setTimeout(() => {
        window.history.go(0)
    }, 2000)
}
export function config_init(that) {
    // that.http.api('get_settings').then(res => {
    //     localStorage.setItem('config', JSON.stringify(res.data))
    // })
}
